module.exports = __webpack_public_path__ + "img/psm.c237ec1f.png";